export const imprint = "/imprint"
export const termsAndConditions = "/terms-and-conditions"
export const privacyPolicy = "/privacy-policy"
export const openSourceAttribution = "/open-source-attribution"
